import { connect } from 'react-redux';
import LoaderModal from './loaderModal';

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, {})(LoaderModal);
